import { DialogProps, Typography } from '@mui/material';
import { QueryKey, Secret } from 'api/model.ts';
import InfoDialog from './InfoDialog';
import { useQuery } from '@tanstack/react-query';
import { getModelsUsingSecret } from 'api/secrets/requests';
import ModelRenderer from 'components/form/CustomRenderers/ModelRenderer';

type Props = DialogProps & {
  secret: Secret;
  open: boolean;
  onClose: () => void;
};

const SecretModelUsageDialog = ({ secret, open, onClose }: Props) => {
  const { data: models, isLoading: isLoadingModels } = useQuery({
    queryKey: [QueryKey.SecretUsage, { secretId: secret.id }],
    queryFn: () => getModelsUsingSecret(secret.id),
    enabled: open,
  });

  if (isLoadingModels) {
    return (
      <InfoDialog
        open={open}
        maxWidth="sm"
        fullWidth
        buttonsSettings={{ confirmText: 'Close' }}
        onCancel={onClose}
        onConfirm={onClose}
      >
        <Typography>Loading...</Typography>
      </InfoDialog>
    );
  }

  return (
    <InfoDialog
      open={open}
      maxWidth="sm"
      fullWidth
      buttonsSettings={{ confirmText: 'Close' }}
      onCancel={onClose}
      onConfirm={onClose}
    >
      <Typography variant="subtitle1" className="mb-4">
        {'LLM models using '}
        <Typography variant="subtitle1" component="span" fontWeight="bold">
          {secret.name}
        </Typography>
        :
      </Typography>
      {models ? (
        models.map((model) => (
          <div key={model.id} className="mb-4">
            <ModelRenderer modelId={model.id} models={models} />
          </div>
        ))
      ) : (
        <Typography variant="body2" color="text.disabled">
          This secret is not used in any LLM models.
        </Typography>
      )}
    </InfoDialog>
  );
};

export default SecretModelUsageDialog;
